var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef, useEffect, useCallback } from 'react';
import FocusTrap from 'react-focus-lock';
import { RemoveScroll } from 'react-remove-scroll';
import { KEYBOARD } from 'modules/constants';
import { Portal } from 'modules/v2/foundation/PortalProvider/Portal';
import { Container } from './styled';
function Modal(props) {
    const { children, initialFocusRef, closeOnOutsideClick = true, closeOnEscape = true, onClose, autoFocus = true, overlay = false } = props, restProps = __rest(props, ["children", "initialFocusRef", "closeOnOutsideClick", "closeOnEscape", "onClose", "autoFocus", "overlay"]);
    const overlayRef = useRef(null);
    useEffect(() => {
        const handleDocumentClick = (event) => {
            const clickedOutside = event.target === overlayRef.current;
            if (closeOnOutsideClick && clickedOutside && onClose) {
                onClose(event);
            }
        };
        const handleDocumentKeyUp = (event) => {
            const pressedEscapeKey = event.key === KEYBOARD.ESC;
            if (closeOnEscape && pressedEscapeKey && onClose) {
                onClose(event);
            }
        };
        document.addEventListener('click', handleDocumentClick);
        document.addEventListener('keyup', handleDocumentKeyUp);
        return () => {
            document.removeEventListener('click', handleDocumentClick);
            document.removeEventListener('keyup', handleDocumentKeyUp);
        };
    });
    const handleActivation = useCallback(() => {
        if (initialFocusRef && initialFocusRef.current) {
            initialFocusRef.current.focus();
        }
    }, [initialFocusRef]);
    return (<Portal>
      <FocusTrap autoFocus={autoFocus} returnFocus onActivation={handleActivation}>
        <RemoveScroll>
          <Container $overlay={overlay} aria-modal="true" {...restProps} ref={overlayRef}>
            {children}
          </Container>
        </RemoveScroll>
      </FocusTrap>
    </Portal>);
}
export default Modal;
